<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <span class="section-title">TRANSFERENCIAS DE PRODUCCIÓN</span>
              <router-link
                :to="{ name: 'Transfers Create' }"
                class="btn btn-sm bg-gradient-warning mb-0"
                data-toggle="tooltip"
                data-original-title="Agregar transferencia"
              >
                Agregar <i class="fa fa-plus ms-1"></i>
              </router-link>
            </div>

            <div class="row">
              <!-- Columna de búsqueda -->
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar transferencia..." @input="fetchData(null)" />
              </div>
              <div class="col-md-3 mb-3">
                <label for="statusFilter" class="mb-1">Estado</label>
                <select v-model="statusFilter" id="statusFilter" class="form-control" @change="fetchData(null)">
                  <option value="">Todos</option>
                  <option value="pending">Pendiente</option>
                  <option value="completed">Completado</option>
                  <option value="cancelled">Cancelado</option>
                </select>
              </div>
              <div class="col-md-2 mb-3">
                <label for="startDate" class="mb-1">Fecha Inicio</label>
                <input type="date" v-model="startDate" id="startDate" class="form-control" @change="fetchData(null)" />
              </div>
              <div class="col-md-2 mb-3">
                <label for="endDate" class="mb-1">Fecha Fin</label>
                <input type="date" v-model="endDate" id="endDate" class="form-control" @change="fetchData(null)" />
              </div>
            </div>

          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      ID</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Usuario</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Productos</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Observaciones</th>
                    <th class="text-secondary text-center text-uppercase text-xxs font-weight-bolder opacity-7">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ new Date(value.transfer_date).toLocaleDateString('es-ES') }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.user?.name ?? 'N/A' }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="px-2 py-1 text-start">
                        <template v-for="(detail, i) in value.details" :key="`d-${i}`">
                          <p class="mb-0 text-sm">
                            {{ detail.inventory?.name ?? 'N/A' }} 
                            <span class="badge badge-sm bg-gradient-info">
                              ({{ detail.current_stock }})
                            </span>
                          </p>
                        </template>
                      </div>
                    </td>
                    <td>
                      <div class="px-2 py-1 text-center">
                        <span class="badge badge-sm bg-gradient-warning" v-if="value.status === 'pending'">Pendiente</span>
                        <span class="badge badge-sm bg-gradient-success" v-if="value.status === 'completed'">Completado</span>
                        <span class="badge badge-sm bg-gradient-danger" v-if="value.status === 'cancelled'">Cancelado</span>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewNotes(value.notes)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Ver observaciones">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Transfers Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro" style="margin-left: 15px;">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>

                      <a @click="deleteTransfer(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="7" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'TransfersTable',
  data() {
    return {
      searchQuery: '',
      statusFilter: '',
      startDate: '',
      endDate: '',
    };
  },
  computed: {
    ...mapGetters('productionTransfers', ['transfers', 'pagination', 'isLoading']),
    currentPage() {
      return this.$store.state.productionTransfers.currentPage;
    },
    lastPage() {
      return this.$store.state.productionTransfers.lastPage;
    },
    data() {
      return this.transfers;
    },
    links() {
      return this.$store.getters['productionTransfers/pagination']?.links ?? [];
    },
  },
  methods: {
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        status: this.statusFilter,
        start_date: this.startDate,
        end_date: this.endDate,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('productionTransfers/fetchData', params);
    },
    viewNotes(notes) {
      Swal.fire({
        title: 'Observaciones',
        text: notes || 'No hay observaciones disponibles.',
        icon: 'info',
        confirmButtonText: 'Aceptar'
      });
    },
    async deleteTransfer(transferId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionTransfers/delete", transferId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data?.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al eliminar el registro',
        });
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>

